var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{attrs:{"title":_vm.$store.getters['translations/getLabel']('STORES')}}),_c('b-container',[_c('StoreList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }